<template>

    <div :class="[!is_enabled ? 'cursor-pointer hover:bg-gray-100' : '', 'group']" @click="clickRow">

        <div class="flex items-center font-bold flex-row justify-between px-4 py-5 sm:p-6">

            <div class="flex flex-grow items-center gap-3">
                <div class="w-12 h-12 rounded-2xl flex items-center justify-center" style="background-color:#ED6744;">
                    <img src="/img/hubspot-logo.svg" class="size-7" />
                </div>
                <div class="flex flex-col items-start">
                    <span>HubSpot Service Hub</span>
                </div>
            </div>
            <div class="flex text-white bg items-center" v-if="trigger">
                <div
                    class="inline-flex items-center px-0 py-2 bg-white border border-transparent rounded-md font-semibold text-xs text-birdie-green uppercase tracking-widest ">
                    Connected
                </div>
            </div>
            <transition name="fade">
                <div class="flex text-blue-500 items-center"
                    :class="{ 'opacity-50 pointer-events-none': !$page.props.canManageSettings }"
                    v-if="expandInfo && !is_enabled">
                    <button-link
                        :link="$page.props.canManageSettings ? 'https://app-eu1.hubspot.com/oauth/authorize?client_id=692130de-be98-4319-a2c9-25af13c46ade&redirect_uri=https://app.birdie.so/hubspot/callback&scope=tickets%20sales-email-read%20crm.objects.owners.read%20conversations.read%20settings.users.read%20conversations.write%20crm.objects.contacts.read' : '#'"
                        class="" :title="'Connect Birdie with HubSpot Service Hub'">
                        Connect
                    </button-link>

                </div>
            </transition>
        </div>


        <Flows :visible="expandInfo" :fixed="is_enabled" :flows="flows" :docs="docs" :name="name" />

        <div v-if="trigger" class="bg-gray-50 rounded-b-md px-4 py-5 sm:p-8 border-t border-gray-100">

            <div class="flex flex-row mt-3" v-if="trigger && !is_modal && !trigger.token">
                <div class="flex items-center flex-grow">
                    <!-- <span class="text-sm text-gray-600" v-if="trigger.token && false">
                        Please visit <a href="https://www.freshworks.com/apps/freshdesk/screen_recording_by_zest_1" :title="'Freshdesk '+appname+' app'" target="_blank"
                            class="text-blue-500 mx-1 hover:text-blue-600 hover:underline">
                                Freshworks App Store</a> to install {{app_name}}, or take a look at <a href="https://docs.birdie.so/birdie-docs/helpdesk/freshdesk" target="_blank" title="Freshchat integration help"
                                class="text-blue-500 mx-1 hover:text-blue-600 hover:underline">this guide</a> if you need help.
                    </span> -->
                    <span class="text-sm text-yellow-600 font-bold">
                        Installation not complete, <a
                            href="https://app-eu1.hubspot.com/oauth/authorize?client_id=692130de-be98-4319-a2c9-25af13c46ade&redirect_uri=https://app.birdie.so/hubspot/callback&scope=tickets%20crm.objects.owners.read%20conversations.read%20settings.users.read%20conversations.write%20crm.objects.contacts.read"
                            class="text-blue-500 mx-1 hover:text-blue-600 hover:underline">click here to retry
                            installation</a>.
                        <!-- <br />Go to <a href="https://www.freshworks.com/apps/freshdesk/screen_recording_by_zest_1" :title="'Freshdesk '+appname+' app'" target="_blank"
                            class="text-blue-500 mx-1 hover:text-blue-600 hover:underline">
                                Freshworks App Store</a> to install {{app_name}}, or take a look at <a href="https://docs.birdie.so/birdie-docs/helpdesk/freshdesk" target="_blank" title="Freshchat integration help"
                                class="text-blue-500 mx-1 hover:text-blue-600 hover:underline">this guide</a> if you need help. -->
                    </span>
                </div>
            </div>



            <div class="flex flex-col mt-1" v-if="trigger && !is_modal">
                <div class="flex justify-between items-center pr-2">
                    <h2 class="font-bold flex items-center gap-x-2">
                        HubSpot Forms | Optional &nbsp;<docs-link
                            href="https://docs.birdie.so/birdie-docs/helpdesk/hubspot-service-hub/flows/forms" />
                    </h2>
                </div>
                <div class="flex flex-col mt-2" v-if="trigger && !is_modal">
                    <div class="flex items-center flex-grow gap-x-2">
                        <h3 class="flex items-center">Link to use when adding Birdie in your HubSpot Forms:</h3>
                        <div class="flex flex-col justify-between items-start gap-x-2">
                            <div class="flex justify-between text-sm">
                                <span
                                    class="cursor-pointer bg-gray-200 text-gray-500 hover:text-gray-600 px-3 py-1 rounded mt-1 flex items-center flex-shrink"
                                    v-clipboard:copy="hubspot_snippet" v-clipboard:success="copied">{{
                                    hubspot_snippet }}
                                    <ClipboardIcon class="h-3 w-3 ml-1"
                                        v-tippy="{ content: 'copy in your clipboard' }" />
                                </span>
                                <div class="flex flex-grow"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <jet-section-border v-if="trigger && !is_modal" />

            <div class="flex flex-col" v-if="trigger && !is_modal">
                <div class="flex justify-between items-center pr-2">
                    <h2 class="font-bold flex items-center gap-x-2">
                        HubSpot Snippets | Optional &nbsp;<docs-link
                            href="https://docs.birdie.so/birdie-docs/helpdesk/hubspot-service-hub/flows/human-request-via-snippet" />
                    </h2>
                </div>
                <div class="flex flex-col mt-2" v-if="trigger && !is_modal">
                    <div class="flex items-center flex-grow gap-x-2">
                        <h3 class="flex items-center">Link to use for the snippet:</h3>
                        <div class="flex flex-col justify-between items-start gap-x-2">
                            <div class="flex justify-between text-sm">
                                <span
                                    class="cursor-pointer bg-gray-200 text-gray-500 hover:text-gray-600 px-3 py-1 rounded mt-1 flex items-center flex-shrink"
                                    v-clipboard:copy="hubspot_code" v-clipboard:success="copied">{{
                                    hubspot_code }}
                                    <ClipboardIcon class="h-3 w-3 ml-1"
                                        v-tippy="{ content: 'copy in your clipboard' }" />
                                </span>
                                <div class="flex flex-grow"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>




        </div>

    </div>

</template>

<script>
import ButtonLink from '@/Jetstream/ButtonLink'
import ListToggle from '@/Components/UI/ListToggle'
import JetSectionBorder from '@/Jetstream/SectionBorder'

import { ClipboardIcon } from "@heroicons/vue/16/solid"
import Flows from '@/Components/Settings/Integrations/Flows'

export default {

    props: ['the_trigger', "is_modal", "hubspot_snippet", "flows", "docs", "name"],

    components: {
        ButtonLink, ListToggle, ClipboardIcon,
        JetSectionBorder, Flows
    },

    created: function () {
        if (this.the_trigger) {
            this.trigger = this.the_trigger
            this.engine = JSON.parse(this.the_trigger.details)
        }
    },

    data() {
        return {
            trigger: null,
            engine: {},
            is_enabled: this.the_trigger != false,
            expandInfo: false,
            hubspot_code: `https://${this.$page.props.user.current_team.slugname}.birdie.so/urec/hubspot?email={{contact.email}}&ticket={{ticket.hs_object_id}}`
        }
    },

    mounted: function () {
        //console.log(this.trigger);
    },

    methods: {
        clickRow: function () {
            if (this.is_enabled) {
                return
            }
            this.expandInfo = !this.expandInfo
        },
        copied: function () {
            let options = {
                type: "default",
                timeout: 6000,
                position: "top-right",
                hideProgressBar: false,
            }
            this.$moshaToast("Code snippet copied in your clipboard!", options)
        },
    },

    computed: {
        enabled: {
            get: function () {
                return this.trigger.enabled == 1
            },
            set: function (newValue) {
                // do nothing
            }
        }
    }

}

</script>

<style scoped></style>
